import { IconButton, Trigger, useBulkEdit } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationUsersRolesDrawer } from "./ApplicationUsersRolesDrawer";

interface Props {
	applicationId: string;
}

export const ApplicationUserBulkEditAction: FC<Props> = ({ applicationId }) => {
	const { t } = useTranslation();
	const { selectedRows, availableItemIds } = useBulkEdit();

	return (
		<Trigger
			render={(props) => (
				<ApplicationUsersRolesDrawer {...props} userIds={selectedRows} applicationId={applicationId} />
			)}
		>
			{(props) => (
				<IconButton
					{...props}
					type="button"
					title={t("Edit roles")}
					size="small"
					disabled={selectedRows.length === 0 || availableItemIds.length === 0}
					icon="edit"
				/>
			)}
		</Trigger>
	);
};
